<template>
  <v-row>
    <v-col cols="12">
      <base-card>
        <v-card-title>
          <v-btn
            dark
            color="secondary"
            class="ma-2"
            outlined
            @click="$router.back()"
          >
            <v-icon>mdi-arrow-left</v-icon>
            Back
          </v-btn>
        </v-card-title>
        <v-card-title class="d-flex justify-space-between pl-6 mb-3">
          {{ item.header }}
          <v-btn
            color="primary"
            @click="$router.push({ name: 'create-course-item-question' })"
          >
            <v-icon>mdi-plus</v-icon>
            Create New
          </v-btn>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :options.sync="options"
          :items="getCourseItemQuestions"
          :loading="getCourseItemsLoading"
          item-key="id"
          class="elevation-1 data-table"
        >
          <template v-slot:item.body_text="{ item }">
            <td class="pa-3">
              <template>
                <div v-html="item.body_text"></div>
              </template>
            </td>
          </template>
          <template v-slot:item.help_text="{ item }">
            <td class="pa-3">
              <template>
                <div v-html="item.help_text"></div>
              </template>
            </td>
          </template>
          <template v-slot:item.help_text_two="{ item }">
            <td class="pa-3">
              <template>
                <div v-html="item.help_text_two"></div>
              </template>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="success"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="
                      $router.push(
                        `/app/course/${course.id}/course-item/${itemId}/question/${item.id}/edit`
                      )
                    "
                  >
                    <v-icon>mdi-pencil-box-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="danger"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    icon
                    @click="showRemoveDialog(item)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </base-card>
      <v-dialog v-model="dialog" max-width="320">
        <v-card v-if="selected">
          <v-card-title class="text-h6"> Delete Question </v-card-title>
          <v-card-text>
            The question will be deleted permanently. Are you sure?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false"> Cancel </v-btn>
            <v-btn color="danger" text @click="deleteItem"> Delete </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { ITEM_TYPES } from "@/shared/constants";
import { find, get } from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  metaInfo: {
    title: "Course Item Question",
  },

  data() {
    return {
      itemTypes: ITEM_TYPES,
      id: get(this.$route, "params.id"),
      itemId: get(this.$route, "params.itemId"),
      options: {},
      selected: null,
      dialog: false,
      headers: [
        {
          text: "Body Text",
          value: "body_text",
          width: "30%",
          sortable: false,
        },
        { text: "Order", value: "order", sortable: false },
        { text: "Score", value: "score", sortable: false },
        { text: "Max Amount Try", value: "max_amount_try", sortable: false },
        {
          text: "Help Text",
          value: "help_text",
          width: "30%",
          sortable: false,
        },
        {
          text: "Timeout Correct Answer",
          value: "question_timeout_correct_answer",
          sortable: false,
        },
        {
          text: "Timeout Wrong Answer",
          value: "question_timeout_wrong_answer",
          sortable: false,
        },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },

  computed: {
    ...mapGetters([
      "getCourseLookup",
      "getCourseItems",
      "getCourseItemQuestions",
      "getCourseParentItems",
      "getCourseItemsLoading",
    ]),

    course() {
      return get(find(this.getCourseLookup, { course_id: +this.id }), "course");
    },

    item() {
      return find(this.getCourseItems, { id: +this.itemId });
    },
  },

  methods: {
    ...mapActions([
      "setCourseItems",
      "setCourseItemQuestions",
      "deleteQuestion",
    ]),

    paginate() {
      this.setCourseItems({
        id: this.id,
        ...this.filters,
      });
    },

    showRemoveDialog(item) {
      this.selected = item;
      this.dialog = true;
    },

    async deleteItem() {
      try {
        await this.deleteQuestion(this.selected.id);

        this.selected = null;
        this.dialog = false;

        this.$store.dispatch("showSnackbar", "Question deleted.");
      } catch (error) {
        console.error("DEBUG: error", error);
        this.$store.dispatch("showSnackbar", "Oops, something went wrong!");
      }
    },
  },
};
</script>
<style lang="scss" scoped></style>
